export const assetCSVFormat = (dataResponse) => {
  for (let i = 0; i < dataResponse.length; i++) {
    let kv = '';

    dataResponse[i].identifiers.forEach((obj) =>
      obj.key != '' && obj.value != '' ? (kv += '(' + obj.key + '+' + obj.value + ')') : '',
    );

    dataResponse[i] = {
      id: dataResponse[i].id,
      name: dataResponse[i].name,
      created: dataResponse[i].created,
      assetType: dataResponse[i].assetType,
      movementThreshold: dataResponse[i].movementThreshold,
      lastCheckIn: dataResponse[i].lastCheckin,
      beacons: dataResponse[i].beacons,
      keywords: dataResponse[i].keywords.join('+'),
      location: dataResponse[i].location,
      gpsLocation: dataResponse[i].gpsLocation,
      identifiers: kv,
      scans: dataResponse[i].scans,
      status: dataResponse[i].status,
      favorite: dataResponse[i].favorite,
      locationBeaconId: dataResponse[i].locationBeaconId,
      preSignedImageUrl: dataResponse[i].preSignedImageUrl,
    };
  }
  return dataResponse;
};
